// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { AxiosInstance, AxiosResponse, AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import axios from 'axios';
import FormData from 'form-data';
import { Moment } from 'moment';
import { Inject, Scoped } from 'vue-di';

/* tslint:disable:no-unused-locals */
import {
    Serializer,
    UNKNOWN_BASE_TYPE,
    AccountExternalIdType,
    Ansi837MedicalClaimRequestModel,
    ClaimAdjudicationRequest,
    ClaimAdjudicationResponse,
    ClaimV1ClaimAccumulatorByMemberNumberResponse,
    ClaimV1ClaimAccumulatorSearchResponse,
    ClaimV1ClaimClaimV1ClaimAccumulatorByMemberNumberAccumulatorByMemberNumberRequest,
    ClaimV1ClaimClaimV1ClaimAccumulatorSearchAccumulatorSearchRequest,
    ClaimV1ClaimClaimV1ClaimGroupViewSearchGroupViewSearchRequest,
    ClaimV1ClaimClaimV1ClaimMedicalClaimSearchMedicalClaimSearchRequest,
    ClaimV1ClaimClaimV1ClaimPharmacyClaimSearchPharmacyClaimSearchRequest,
    ClaimV1ClaimCreateAnsi837MedicalClaimResponse,
    ClaimV1ClaimCreateOpenClaimResponse,
    ClaimV1ClaimMedicalClaimSearchResponse,
    ClaimV1ClaimPaymentBatchByIdResponse,
    ClaimV1ClaimPharmacyClaimSearchResponse,
    ClaimV1ClaimV1PlaceOrderDefaultResponse,
    ClaimV1GroupViewSearchClaimsByAccountExternalIdResponse,
    ClaimV1TypesClaimStatusResponse,
    ClaimV1TypesReasonCodesResponse,
    ClaimV1TypesRejectTypesResponse,
    ClaimV1TypesSiteBillingCodesResponse,
    CodeFilterRequest,
    CreateClaimRequestModel,
    GatewayError,
    IPlaceOrderRequestModel,
} from '@trialcard/apigateway.models';
import { Authentication, ApiKeyAuth, OAuth, OAuthTokenProvider, NullAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import * as enums from '@trialcard/enums';
import {
    createAxiosHeaders,
    EntLibServiceClient,
    RequestFile,
    X_TC_USERID,
    ConfigureWith,
    SetPackageName,
} from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols.js';
import { configure } from './configure.js';

// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================

@Scoped
@ConfigureWith(configure)
@SetPackageName('@trialcard/apigateway.client')
export class EdgeClaimApi extends EntLibServiceClient {
    protected authentications: {
        'Token': Authentication;
        'UserId': ApiKeyAuth;
    }

    public constructor(
        @Inject(AXIOS) private readonly axios: AxiosInstance,
        @Inject(X_TC_USERID) xTcUserId: string,
        @Inject(AUDIENCE) audience: string,
        @Inject(BASE_PATH) url: string,
        @Inject(OAUTH_TOKEN_PROVIDER) tokenProvider: OAuthTokenProvider) {
        super();
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'UserId': new ApiKeyAuth('header', 'x-tc-userid'),
        };

        if ((this.authentications as any).UserId) {
            (this.authentications as any).UserId.apiKey = xTcUserId;
        }
    }

    /**
     * 
     * @param claimV1ClaimClaimV1ClaimAccumulatorByMemberNumberAccumulatorByMemberNumberRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async claimAccumulatorByMemberNumber (claimV1ClaimClaimV1ClaimAccumulatorByMemberNumberAccumulatorByMemberNumberRequest: ClaimV1ClaimClaimV1ClaimAccumulatorByMemberNumberAccumulatorByMemberNumberRequest, xProgramId?: string): Promise<AxiosResponse<ClaimV1ClaimAccumulatorByMemberNumberResponse>> {
        const _url_ = '/edge/claim/v1/Claim/accumulatorByMemberNumber';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'claimV1ClaimClaimV1ClaimAccumulatorByMemberNumberAccumulatorByMemberNumberRequest' is not null or undefined
        if (claimV1ClaimClaimV1ClaimAccumulatorByMemberNumberAccumulatorByMemberNumberRequest === null || claimV1ClaimClaimV1ClaimAccumulatorByMemberNumberAccumulatorByMemberNumberRequest === undefined) {
            throw new Error('Required parameter claimV1ClaimClaimV1ClaimAccumulatorByMemberNumberAccumulatorByMemberNumberRequest was null or undefined when calling claimAccumulatorByMemberNumber.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(claimV1ClaimClaimV1ClaimAccumulatorByMemberNumberAccumulatorByMemberNumberRequest, "ClaimV1ClaimClaimV1ClaimAccumulatorByMemberNumberAccumulatorByMemberNumberRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<ClaimV1ClaimAccumulatorByMemberNumberResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "ClaimV1ClaimAccumulatorByMemberNumberResponse");
        }
        return response;
    }
    /**
     * 
     * @param claimV1ClaimClaimV1ClaimAccumulatorSearchAccumulatorSearchRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async claimAccumulatorSearch (claimV1ClaimClaimV1ClaimAccumulatorSearchAccumulatorSearchRequest: ClaimV1ClaimClaimV1ClaimAccumulatorSearchAccumulatorSearchRequest, xProgramId?: string): Promise<AxiosResponse<ClaimV1ClaimAccumulatorSearchResponse>> {
        const _url_ = '/edge/claim/v1/Claim/accumulatorSearch';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'claimV1ClaimClaimV1ClaimAccumulatorSearchAccumulatorSearchRequest' is not null or undefined
        if (claimV1ClaimClaimV1ClaimAccumulatorSearchAccumulatorSearchRequest === null || claimV1ClaimClaimV1ClaimAccumulatorSearchAccumulatorSearchRequest === undefined) {
            throw new Error('Required parameter claimV1ClaimClaimV1ClaimAccumulatorSearchAccumulatorSearchRequest was null or undefined when calling claimAccumulatorSearch.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(claimV1ClaimClaimV1ClaimAccumulatorSearchAccumulatorSearchRequest, "ClaimV1ClaimClaimV1ClaimAccumulatorSearchAccumulatorSearchRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<ClaimV1ClaimAccumulatorSearchResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "ClaimV1ClaimAccumulatorSearchResponse");
        }
        return response;
    }
    /**
     * 
     * @param ansi837MedicalClaimRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async claimCreateAnsi837MedicalClaim (ansi837MedicalClaimRequestModel: Ansi837MedicalClaimRequestModel, xProgramId?: string): Promise<AxiosResponse<ClaimV1ClaimCreateAnsi837MedicalClaimResponse>> {
        const _url_ = '/edge/claim/v1/Claim/createAnsi837MedicalClaim';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'ansi837MedicalClaimRequestModel' is not null or undefined
        if (ansi837MedicalClaimRequestModel === null || ansi837MedicalClaimRequestModel === undefined) {
            throw new Error('Required parameter ansi837MedicalClaimRequestModel was null or undefined when calling claimCreateAnsi837MedicalClaim.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(ansi837MedicalClaimRequestModel, "Ansi837MedicalClaimRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<ClaimV1ClaimCreateAnsi837MedicalClaimResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "ClaimV1ClaimCreateAnsi837MedicalClaimResponse");
        }
        return response;
    }
    /**
     * 
     * @param createClaimRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async claimCreateOpenClaim (createClaimRequestModel: CreateClaimRequestModel, xProgramId?: string): Promise<AxiosResponse<ClaimV1ClaimCreateOpenClaimResponse>> {
        const _url_ = '/edge/claim/v1/Claim/createOpenClaim';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'createClaimRequestModel' is not null or undefined
        if (createClaimRequestModel === null || createClaimRequestModel === undefined) {
            throw new Error('Required parameter createClaimRequestModel was null or undefined when calling claimCreateOpenClaim.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(createClaimRequestModel, "CreateClaimRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<ClaimV1ClaimCreateOpenClaimResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "ClaimV1ClaimCreateOpenClaimResponse");
        }
        return response;
    }
    /**
     * 
     * @param claimV1ClaimClaimV1ClaimGroupViewSearchGroupViewSearchRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async claimGroupViewSearch (claimV1ClaimClaimV1ClaimGroupViewSearchGroupViewSearchRequest: ClaimV1ClaimClaimV1ClaimGroupViewSearchGroupViewSearchRequest, xProgramId?: string): Promise<AxiosResponse<any>> {
        const _url_ = '/edge/claim/v1/Claim/groupViewSearch';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'claimV1ClaimClaimV1ClaimGroupViewSearchGroupViewSearchRequest' is not null or undefined
        if (claimV1ClaimClaimV1ClaimGroupViewSearchGroupViewSearchRequest === null || claimV1ClaimClaimV1ClaimGroupViewSearchGroupViewSearchRequest === undefined) {
            throw new Error('Required parameter claimV1ClaimClaimV1ClaimGroupViewSearchGroupViewSearchRequest was null or undefined when calling claimGroupViewSearch.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(claimV1ClaimClaimV1ClaimGroupViewSearchGroupViewSearchRequest, "ClaimV1ClaimClaimV1ClaimGroupViewSearchGroupViewSearchRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<any>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "any");
        }
        return response;
    }
    /**
     * 
     * @param claimV1ClaimClaimV1ClaimMedicalClaimSearchMedicalClaimSearchRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async claimMedicalClaimSearch (claimV1ClaimClaimV1ClaimMedicalClaimSearchMedicalClaimSearchRequest: ClaimV1ClaimClaimV1ClaimMedicalClaimSearchMedicalClaimSearchRequest, xProgramId?: string): Promise<AxiosResponse<ClaimV1ClaimMedicalClaimSearchResponse>> {
        const _url_ = '/edge/claim/v1/Claim/medicalClaimSearch';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'claimV1ClaimClaimV1ClaimMedicalClaimSearchMedicalClaimSearchRequest' is not null or undefined
        if (claimV1ClaimClaimV1ClaimMedicalClaimSearchMedicalClaimSearchRequest === null || claimV1ClaimClaimV1ClaimMedicalClaimSearchMedicalClaimSearchRequest === undefined) {
            throw new Error('Required parameter claimV1ClaimClaimV1ClaimMedicalClaimSearchMedicalClaimSearchRequest was null or undefined when calling claimMedicalClaimSearch.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(claimV1ClaimClaimV1ClaimMedicalClaimSearchMedicalClaimSearchRequest, "ClaimV1ClaimClaimV1ClaimMedicalClaimSearchMedicalClaimSearchRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<ClaimV1ClaimMedicalClaimSearchResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "ClaimV1ClaimMedicalClaimSearchResponse");
        }
        return response;
    }
    /**
     * 
     * @param id 
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async claimPaymentBatchById (id: number, xProgramId?: string): Promise<AxiosResponse<ClaimV1ClaimPaymentBatchByIdResponse>> {
        const _url_ = '/edge/claim/v1/Claim/paymentBatchById/{id}'
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'id' is not null or undefined
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling claimPaymentBatchById.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<ClaimV1ClaimPaymentBatchByIdResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "ClaimV1ClaimPaymentBatchByIdResponse");
        }
        return response;
    }
    /**
     * 
     * @param claimV1ClaimClaimV1ClaimPharmacyClaimSearchPharmacyClaimSearchRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async claimPharmacyClaimSearch (claimV1ClaimClaimV1ClaimPharmacyClaimSearchPharmacyClaimSearchRequest: ClaimV1ClaimClaimV1ClaimPharmacyClaimSearchPharmacyClaimSearchRequest, xProgramId?: string): Promise<AxiosResponse<ClaimV1ClaimPharmacyClaimSearchResponse>> {
        const _url_ = '/edge/claim/v1/Claim/pharmacyClaimSearch';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'claimV1ClaimClaimV1ClaimPharmacyClaimSearchPharmacyClaimSearchRequest' is not null or undefined
        if (claimV1ClaimClaimV1ClaimPharmacyClaimSearchPharmacyClaimSearchRequest === null || claimV1ClaimClaimV1ClaimPharmacyClaimSearchPharmacyClaimSearchRequest === undefined) {
            throw new Error('Required parameter claimV1ClaimClaimV1ClaimPharmacyClaimSearchPharmacyClaimSearchRequest was null or undefined when calling claimPharmacyClaimSearch.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(claimV1ClaimClaimV1ClaimPharmacyClaimSearchPharmacyClaimSearchRequest, "ClaimV1ClaimClaimV1ClaimPharmacyClaimSearchPharmacyClaimSearchRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<ClaimV1ClaimPharmacyClaimSearchResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "ClaimV1ClaimPharmacyClaimSearchResponse");
        }
        return response;
    }
    /**
     * 
     * @param iPlaceOrderRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async claimV1PlaceOrder (iPlaceOrderRequestModel: IPlaceOrderRequestModel, xProgramId?: string): Promise<AxiosResponse<ClaimV1ClaimV1PlaceOrderDefaultResponse>> {
        const _url_ = '/edge/claim/v1/PlaceOrder';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'iPlaceOrderRequestModel' is not null or undefined
        if (iPlaceOrderRequestModel === null || iPlaceOrderRequestModel === undefined) {
            throw new Error('Required parameter iPlaceOrderRequestModel was null or undefined when calling claimV1PlaceOrder.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(iPlaceOrderRequestModel, "IPlaceOrderRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<ClaimV1ClaimV1PlaceOrderDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "ClaimV1ClaimV1PlaceOrderDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param claimAdjudicationRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async clientAdjudicationThirdParty (claimAdjudicationRequest: ClaimAdjudicationRequest, xProgramId?: string): Promise<AxiosResponse<ClaimAdjudicationResponse>> {
        const _url_ = '/edge/claim/v1/adjudication/thirdParty';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'claimAdjudicationRequest' is not null or undefined
        if (claimAdjudicationRequest === null || claimAdjudicationRequest === undefined) {
            throw new Error('Required parameter claimAdjudicationRequest was null or undefined when calling clientAdjudicationThirdParty.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(claimAdjudicationRequest, "ClaimAdjudicationRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<ClaimAdjudicationResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "ClaimAdjudicationResponse");
        }
        return response;
    }
    /**
     * 
     * @param externalIdType 
     * @param externalId 
     * @param start 
     * @param pageSize 
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async groupViewSearchClaimsByAccountExternalId (externalIdType: enums.AccountExternalIdType, externalId: string, start: number, pageSize: number, xProgramId?: string): Promise<AxiosResponse<ClaimV1GroupViewSearchClaimsByAccountExternalIdResponse>> {
        const _url_ = '/edge/claim/v1/GroupViewSearch/claimsByAccountExternalId/{externalIdType}/{externalId}/{start}/{pageSize}'
            .replace('{' + 'externalIdType' + '}', encodeURIComponent(String(externalIdType)))
            .replace('{' + 'externalId' + '}', encodeURIComponent(String(externalId)))
            .replace('{' + 'start' + '}', encodeURIComponent(String(start)))
            .replace('{' + 'pageSize' + '}', encodeURIComponent(String(pageSize)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'externalIdType' is not null or undefined
        if (externalIdType === null || externalIdType === undefined) {
            throw new Error('Required parameter externalIdType was null or undefined when calling groupViewSearchClaimsByAccountExternalId.');
        }

        // verify required parameter 'externalId' is not null or undefined
        if (externalId === null || externalId === undefined) {
            throw new Error('Required parameter externalId was null or undefined when calling groupViewSearchClaimsByAccountExternalId.');
        }

        // verify required parameter 'start' is not null or undefined
        if (start === null || start === undefined) {
            throw new Error('Required parameter start was null or undefined when calling groupViewSearchClaimsByAccountExternalId.');
        }

        // verify required parameter 'pageSize' is not null or undefined
        if (pageSize === null || pageSize === undefined) {
            throw new Error('Required parameter pageSize was null or undefined when calling groupViewSearchClaimsByAccountExternalId.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<ClaimV1GroupViewSearchClaimsByAccountExternalIdResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "ClaimV1GroupViewSearchClaimsByAccountExternalIdResponse");
        }
        return response;
    }
    /**
     * 
     * @param accountId 
     * @param start 
     * @param pageSize 
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async groupViewSearchClaimsByAccountId (accountId: number, start: number, pageSize: number, xProgramId?: string): Promise<AxiosResponse<ClaimV1GroupViewSearchClaimsByAccountExternalIdResponse>> {
        const _url_ = '/edge/claim/v1/GroupViewSearch/claimsByAccountId/{accountId}/{start}/{pageSize}'
            .replace('{' + 'accountId' + '}', encodeURIComponent(String(accountId)))
            .replace('{' + 'start' + '}', encodeURIComponent(String(start)))
            .replace('{' + 'pageSize' + '}', encodeURIComponent(String(pageSize)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'accountId' is not null or undefined
        if (accountId === null || accountId === undefined) {
            throw new Error('Required parameter accountId was null or undefined when calling groupViewSearchClaimsByAccountId.');
        }

        // verify required parameter 'start' is not null or undefined
        if (start === null || start === undefined) {
            throw new Error('Required parameter start was null or undefined when calling groupViewSearchClaimsByAccountId.');
        }

        // verify required parameter 'pageSize' is not null or undefined
        if (pageSize === null || pageSize === undefined) {
            throw new Error('Required parameter pageSize was null or undefined when calling groupViewSearchClaimsByAccountId.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<ClaimV1GroupViewSearchClaimsByAccountExternalIdResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "ClaimV1GroupViewSearchClaimsByAccountExternalIdResponse");
        }
        return response;
    }
    /**
     * 
     * @param code 
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async typesCauseTypes (code?: string, xProgramId?: string): Promise<AxiosResponse<ClaimV1TypesClaimStatusResponse>> {
        const _url_ = '/edge/claim/v1/Types/causeTypes';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        if (code !== undefined) {
            _params_['code'] = Serializer.serialize(code, "string");
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<ClaimV1TypesClaimStatusResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "ClaimV1TypesClaimStatusResponse");
        }
        return response;
    }
    /**
     * 
     * @param code 
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async typesClaimStatus (code?: string, xProgramId?: string): Promise<AxiosResponse<ClaimV1TypesClaimStatusResponse>> {
        const _url_ = '/edge/claim/v1/Types/claimStatus';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        if (code !== undefined) {
            _params_['code'] = Serializer.serialize(code, "string");
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<ClaimV1TypesClaimStatusResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "ClaimV1TypesClaimStatusResponse");
        }
        return response;
    }
    /**
     * 
     * @param code 
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async typesGroupCodes (code?: string, xProgramId?: string): Promise<AxiosResponse<ClaimV1TypesClaimStatusResponse>> {
        const _url_ = '/edge/claim/v1/Types/groupCodes';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        if (code !== undefined) {
            _params_['code'] = Serializer.serialize(code, "string");
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<ClaimV1TypesClaimStatusResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "ClaimV1TypesClaimStatusResponse");
        }
        return response;
    }
    /**
     * 
     * @param code 
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async typesPaymentBatchStatus (code?: string, xProgramId?: string): Promise<AxiosResponse<ClaimV1TypesClaimStatusResponse>> {
        const _url_ = '/edge/claim/v1/Types/paymentBatchStatus';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        if (code !== undefined) {
            _params_['code'] = Serializer.serialize(code, "string");
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<ClaimV1TypesClaimStatusResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "ClaimV1TypesClaimStatusResponse");
        }
        return response;
    }
    /**
     * 
     * @param code 
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async typesPaymentMethodTypes (code?: string, xProgramId?: string): Promise<AxiosResponse<ClaimV1TypesClaimStatusResponse>> {
        const _url_ = '/edge/claim/v1/Types/paymentMethodTypes';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        if (code !== undefined) {
            _params_['code'] = Serializer.serialize(code, "string");
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<ClaimV1TypesClaimStatusResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "ClaimV1TypesClaimStatusResponse");
        }
        return response;
    }
    /**
     * 
     * @param code 
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async typesProcedureTypes (code?: string, xProgramId?: string): Promise<AxiosResponse<ClaimV1TypesClaimStatusResponse>> {
        const _url_ = '/edge/claim/v1/Types/procedureTypes';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        if (code !== undefined) {
            _params_['code'] = Serializer.serialize(code, "string");
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<ClaimV1TypesClaimStatusResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "ClaimV1TypesClaimStatusResponse");
        }
        return response;
    }
    /**
     * 
     * @param code 
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async typesProcessors (code?: string, xProgramId?: string): Promise<AxiosResponse<ClaimV1TypesClaimStatusResponse>> {
        const _url_ = '/edge/claim/v1/Types/processors';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        if (code !== undefined) {
            _params_['code'] = Serializer.serialize(code, "string");
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<ClaimV1TypesClaimStatusResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "ClaimV1TypesClaimStatusResponse");
        }
        return response;
    }
    /**
     * 
     * @param code 
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async typesReasonCodes (code?: string, xProgramId?: string): Promise<AxiosResponse<ClaimV1TypesReasonCodesResponse>> {
        const _url_ = '/edge/claim/v1/Types/reasonCodes';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        if (code !== undefined) {
            _params_['code'] = Serializer.serialize(code, "string");
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<ClaimV1TypesReasonCodesResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "ClaimV1TypesReasonCodesResponse");
        }
        return response;
    }
    /**
     * 
     * @param code 
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async typesRejectTypes (code?: string, xProgramId?: string): Promise<AxiosResponse<ClaimV1TypesRejectTypesResponse>> {
        const _url_ = '/edge/claim/v1/Types/rejectTypes';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        if (code !== undefined) {
            _params_['code'] = Serializer.serialize(code, "string");
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<ClaimV1TypesRejectTypesResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "ClaimV1TypesRejectTypesResponse");
        }
        return response;
    }
    /**
     * 
     * @param codeFilterRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async typesRemittanceAdviceReasonCode (codeFilterRequest: CodeFilterRequest, xProgramId?: string): Promise<AxiosResponse<ClaimV1TypesClaimStatusResponse>> {
        const _url_ = '/edge/claim/v1/Types/remittanceAdviceReasonCode';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'codeFilterRequest' is not null or undefined
        if (codeFilterRequest === null || codeFilterRequest === undefined) {
            throw new Error('Required parameter codeFilterRequest was null or undefined when calling typesRemittanceAdviceReasonCode.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(codeFilterRequest, "CodeFilterRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<ClaimV1TypesClaimStatusResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "ClaimV1TypesClaimStatusResponse");
        }
        return response;
    }
    /**
     * 
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async typesSiteBillingCodes (xProgramId?: string): Promise<AxiosResponse<ClaimV1TypesSiteBillingCodesResponse>> {
        const _url_ = '/edge/claim/v1/Types/siteBillingCodes';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<ClaimV1TypesSiteBillingCodesResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "ClaimV1TypesSiteBillingCodesResponse");
        }
        return response;
    }
}
